import { Checkbox as MuiCheckbox } from '@mui/material';

export default MuiCheckbox;
